import { ChangeEventHandler, PropsWithChildren } from 'react';
import classNames from 'classnames';
import './Checkbox.scss';
import TipIcon from '@/icons/tip_white.svg?react';

interface Props {
  id?: string;
  name?: string;
  checked: boolean;
  disabled?: boolean;
  type?: 'checkbox' | 'radio';
  onChange: ChangeEventHandler<HTMLInputElement>;
  className?: string;
  inputClassName?: string;
  labelClassName?: string;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  isError?: boolean;
  labelId?: string;
}

const Checkbox = ({
  type = 'checkbox',
  checked,
  onChange,
  onBlur,
  className = '',
  inputClassName = '',
  labelClassName = '',
  isError = false,
  disabled = false,
  id,
  name,
  children,
  labelId,
}: PropsWithChildren<Props>) => {
  const isCheckbox = type === 'checkbox';

  return (
    <div className={`Checkbox ${className}`}>
      <label
        className={classNames(
          'Checkbox__container inline-flex',
          labelClassName,
          {
            Checkbox__error: isError,
          }
        )}
        data-testid={name}
      >
        <input
          id={id}
          name={name}
          type={isCheckbox ? 'checkbox' : 'radio'}
          onChange={onChange}
          checked={checked}
          disabled={disabled}
          onBlur={onBlur}
        />
        <div
          className={classNames('Checkbox__input', inputClassName, {
            Checkbox__radio: !isCheckbox,
            'Checkbox__input--checkbox': isCheckbox,
          })}
          id={labelId + '-checkbox'}
        >
          {isCheckbox && <TipIcon />}
        </div>
        <div className='Checkbox__label' id={labelId}>
          {children}
        </div>
      </label>
    </div>
  );
};

export default Checkbox;
